import React from "react";
import Sidebar from "../../components/Sidebar";
import PartnerConversionConsole from "./components/PartnerConversionConsole";

const PartnerConversionPage = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />
      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Treasury: Partner Conversion</h1>
        <div>
          <PartnerConversionConsole />
        </div>
      </div>
    </div>
  );
};

export default PartnerConversionPage;
